(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:HistoricoaplicacoeswrapperCtrl
   * @description
   * # HistoricoaplicacoeswrapperCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('HistoricoAplicacoesWrapperCtrl', HistoricoAplicacoesWrapperCtrl);

  HistoricoAplicacoesWrapperCtrl.$inject = [
    '$scope',
    '$timeout',
    '$rootScope',
    '$route',
    '$routeParams',
    '$q',
    'RecomendacoesService',
    'InformacoesCultivaresService',
    'ItensService',
    'filterFilter',
    'RecomendacoesSemeaduraService',
    'MessagesService'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function HistoricoAplicacoesWrapperCtrl($scope, $timeout, $rootScope, $route,
    $routeParams, $q, RecomendacoesService, InformacoesCultivaresService, ItensService,
    filterFilter, RecomendacoesSemeaduraService, MessagesService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.activeTab = null;
    vm.open = false;
    vm.disabled = {
      pulverizacao: true,
      recomendacaoSemeadura: true,
      correcaoSolo: true,
      adubacao: true,
      plantio: true
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.activate = activate;
    vm.deactivate = deactivate;
    vm.preparePrint = preparePrint;

    //////////////////////////////////////////
    // Function declarations

    function initialize(event, gleba, notificacao) {
      if (notificacao) {
        if (notificacao.tipo === 'operacao_correcao_solo') {
          vm.activeTab = 'correcaoSolo';
        } else if (notificacao.tipo === 'operacao_adubacao') {
          vm.activeTab = 'adubacao';
        } else if (notificacao.tipo === 'aplicacao') {
          vm.activeTab = 'pulverizacao';
        } else if (notificacao.tipo === 'aplicacao_semeadura') {
          vm.activeTab = 'plantio';
        } else if (notificacao.tipo === 'tratamento_semente') {
          vm.activeTab = 'ts';
        }
      }
      vm.open = true;
    }

    /**
     * Tells nested controller to load its applications
     * @param       {string} type controller type listener name
     */
    function activate(type) {
      $timeout(function() {
        $scope.$broadcast(`${type }Activate`);
      }, 0);
    }

    /**
     * Tells nested controller it has been deactivated
     * @param       {string} type controller type listener name
     */
    function deactivate(type) {
      $timeout(function() {
        $scope.$broadcast(`${type }Deactivate`);
      }, 0);
    }

    function updateRouteParams(tab = null) {
      if (!$scope.map) {
        $route.updateParams({
          activeApplicationsTab: tab,
          activeApplication: null
        });
      }
    }

    function preparePrint(application, event) {
      event.stopPropagation();
      application.loadingRecommendation = true;
      const promises = [];

      const recomendacaoId = (application.allData || {}).recomendacao_id ||
        (application.allData.atributo || {}).recomendacao_id;

      if (recomendacaoId) {
        promises.push(loadRecommendation(application, recomendacaoId));
      }

      promises.push(printInfosCultivares(application));

      application.someHasLote = (application.allData.itens || []).some((item) => !!item.nr_lote);

      $q.all(promises)
        .then(() => {
          application.loadingRecommendation = false;
          $timeout(() => angular.element(event.target.parentElement).click(), 100);
        })
        .catch((error) => {
          console.error('Falha ao preparar dados para impressão', error);
          MessagesService.alert('Falha ao imprimir recomendação.');
          application.loadingRecommendation = false;
        });
    }

    function loadRecommendation(application, recomendacaoId) {
      const getRecommendation = getRecommendationLoadingMethod();
      return getRecommendation(recomendacaoId)
        .then(({ data }) => {
          application.recommendation = data || {};

          if (application.gleba) {
            application.recommendation.gleba = filterFilter(application.recommendation.glebas, {
              id: application.gleba.id
            }, true)[0];
          }
          if (application.recommendation.cultivares) {
            finishPlantio(application);
          }
        });
    }

    function getRecommendationLoadingMethod() {
      switch (vm.activeTab) {
      case 'plantio':
        return RecomendacoesSemeaduraService.get;
      case 'correcaoSolo':
        return RecomendacoesService.getCorrecao;
      case 'adubacao':
        return RecomendacoesService.getAdubacao;
      case 'ts':
        return RecomendacoesSemeaduraService.get;
      default:
        return RecomendacoesService.get;
      }
    }

    function finishPlantio(plantio) {
      plantio.recommendation.cultivares = filterFilter(plantio.recommendation.cultivares, {
        gleba_id: (plantio.gleba || {}).id
      }, true);
      plantio.recommendation.adubos = filterFilter(
        plantio.recommendation.adubos, { gleba_id: (plantio.gleba || {}).id }, true
      );
    }

    function printInfosCultivares(application) {
      if (application.allData.atividade &&
          !application.infosCultivares &&
          application.allData.operacao.id === $scope.$root.parametros.operacao_pulverizacao.id) {
        const { atividade, gleba, safra } = application.allData;
        return InformacoesCultivaresService.get({
          atividade: atividade.id,
          gleba: gleba.id,
          safra: safra.id
        })
          .then(({ data }) => {
            application.infosCultivares = _.uniqBy(data || [], 'cd_insumo');
            application.infosCultivares.forEach((infoCultivar) => {
              infoCultivar.dias_da_emergencia = moment(application.dt_ini).diff(infoCultivar.data_emergencia, 'days');
            });
            return printCultivaresDescricoes(application);
          });
      }
      return $q.resolve();
    }

    function printCultivaresDescricoes(application) {
      const { infosCultivares } = application;

      if (!infosCultivares.length) {
        return $q.resolve();
      }

      return ItensService.listCultivares({
        item: infosCultivares.map((cultivar) => cultivar.cd_insumo).join(),
        tipo_item: 1,
        no_paginate: false
      }).then(({ data }) => {
        data.forEach((item) => {
          const info = _.find(infosCultivares, { cd_insumo: item.item_id });
          info.descricao = item.descricao;
        });
      });
    }

    //////////////////////////////////////////
    // Controller logic

    // instantiate nested controllers and auto-triggers first activation
    $scope.$on('historyApplications', initialize);

    // verifies for permissions
    $rootScope.initialize.then(function() {
      const permissions = Object.keys(vm.disabled);
      permissions.forEach(function(key) {
        vm.disabled[key] = !$rootScope.permissions[key].canRead;
        if (!vm.disabled[key] && !vm.activeTab) {
          vm.activeTab = key;
        }
      });
      if ($routeParams.activeApplicationsTab && !vm.disabled[$routeParams.activeApplicationsTab]) {
        vm.activeTab = $routeParams.activeApplicationsTab;
      }
    });

    // forces reset and reload
    $scope.$on('applications_close', function() {
      vm.open = false;
    });

    $scope.$watch('data', function() {
      if ($scope.data) {
        initialize(null, null, $scope.data.notification);
      }
    });

    $scope.$watch('sidebar', function(value) {
      if (value === 'applications') {
        if ($routeParams.activeRecommendationsTab) {
          vm.activeTab = $routeParams.activeRecommendationsTab;
        }
        initialize();
      }
    });

    $scope.$watch('appWrap.activeTab', function(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        updateRouteParams(newVal);
      }
    });

    $scope.$on('$destroy', function() {
      updateRouteParams();
      $scope.$emit('setCustomGlebaPolygonOptions', null);
      $scope.$emit('setOutrasLegendas', null);
    });
  }
}());
